import axiosInstance from "services/common/axiosInstance";

export interface AddPersonalInfoParams {
  proposal_id: number;
  first_name: string;
  middle_name?: string;
  last_name: string;
  father_full_name: string;
  nationality: string;
  country_of_birth: string;
  place_of_birth: string;
  date_of_birth: string;
  gender: string;
  address: string;
  permanent_address: string;
  local_country_code: string;
  local_mobile_number: string;
  local_office_number?: string;
  local_residence_number?: string;
  home_country_code: string;
  home_mobile_number: string;
  home_office_number?: string;
  home_residence_number?: string;
  homeemail?: string;
  premium_amount?: number | string;
  sum_assured?: number | string;
  planname?: string;
}

export interface AddPersonalInfoResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addPersonalInfoAdmin = async (
  data: AddPersonalInfoParams
): Promise<AddPersonalInfoResponse> => {
  try {
    const response = await axiosInstance.post("/lic/addpersonalinfo_admin", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdatePersonalInfoResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updatePersonalInfoAdmin = async (
  lic_id: number,
  data: AddPersonalInfoParams
): Promise<UpdatePersonalInfoResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatpersonalinfo_admin?lic_id=${lic_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface PersonalInfoRecord {
  id: number;
  proposal_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  father_full_name: string;
  nationality: string;
  country_of_birth: string;
  place_of_birth: string;
  date_of_birth: string;
  gender: string;
  address: string;
  permanent_address: string;
  local_country_code: string;
  local_mobile_number: string;
  local_office_number: string;
  local_residence_number: string;
  home_country_code: string;
  home_mobile_number: string;
  home_office_number: string | null;
  home_residence_number: string | null;
  homeemail: string;
  user_id: number;
  createdon: string;
  updatedon: string;
}

export interface GetPersonalInfoResponse {
  message: string;
  data: PersonalInfoRecord;
  success: boolean;
}

export const getPersonalInfoAdmin = async (
  lic_id: number
): Promise<GetPersonalInfoResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/getpersonalinfo_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface IdentificationRecord {
  id: number;
  lic_id: number;
  passsportnumber: string;
  passport_doe: string;
  citizenshipnumber: string;
  citizenship_doe: string;
  visaissue_country: string;
  visa_doe: string;
}

export interface GetIdentificationResponse {
  message: string;
  data: IdentificationRecord;
  success: boolean;
}

export const getIdentificationAdmin = async (
  lic_id: number
): Promise<GetIdentificationResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/getidentification_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicIdentificationParams {
  lic_id: number;
  passsportnumber: string;
  passport_doe: string | null;
  countryofissue: string;
  citizenshipnumber: string;
  citizenship_doe: string | null;
  visaissue_country: string;
  visa_doe: string | null;
}

export interface AddLicIdentificationResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicIdentificationAdmin = async (
  data: AddLicIdentificationParams
): Promise<AddLicIdentificationResponse> => {
  try {
    const response = await axiosInstance.post(
      "/lic/addlicidentification_admin",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicIdentificationParams {
  passsportnumber: string;
  passport_doe: string | null;
  countryofissue: string;
  citizenshipnumber: string;
  citizenship_doe: string | null;
  visaissue_country: string;
  visa_doe: string | null;
  status: string;
}

export interface UpdateLicIdentificationResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicIdentificationAdmin = async (
  identification_id: number,
  data: UpdateLicIdentificationParams
): Promise<UpdateLicIdentificationResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelicidentification_admin?identification_id=${identification_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicEmploymentParams {
  lic_id: number;
  occupation: string;
  industry_type: string;
  employername: string;
  income_currency: string;
  total_anual_income: number;
  employer_address: string;
  income_source: string;
  isoccupationrisk: number;
  occupationremarks?: string;
}

export interface AddLicEmploymentResponse {
  message: string;
  data: number; 
  success: boolean;
}

export interface UpdateLicEmploymentParams {
  occupation: string;
  industry_type: string;
  employername: string;
  income_currency: string;
  total_anual_income: number;
  employer_address: string;
  income_source: string;
  isoccupationrisk: number;
  status: string;
  occupationremarks?: string;
}

export interface UpdateLicEmploymentResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const addLicEmploymentAdmin = async (
  data: AddLicEmploymentParams
): Promise<AddLicEmploymentResponse> => {
  try {
    const response = await axiosInstance.post(
      "/lic/addlicemployment_admin",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export const updateLicEmploymentAdmin = async (
  employment_id: number,
  data: UpdateLicEmploymentParams
): Promise<UpdateLicEmploymentResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelicemployment_admin?employment_id=${employment_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicEmployment {
  id: number;
  lic_id: number;
  occupation: string;
  industry_type: string;
  employername: string;
  income_currency: string;
  total_anual_income: number;
  employer_address: string;
  income_source: string;
  isoccupationrisk: number;
  occupationremarks?: string;
  status: string;
  createdon: string;
  updatedon: string | null;
}

export interface ListLicEmploymentResponse {
  message: string;
  data: LicEmployment[];
  success: boolean;
}

export const listLicEmploymentAdmin = async (
  lic_id: number
): Promise<ListLicEmploymentResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listlicemployment_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicOtherPolicyRecord {
  id: number;
  lic_id: number;
  [key: string]: unknown;
}

export interface ListLicOtherPolicyResponse {
  message: string;
  data: LicOtherPolicyRecord[];
  success: boolean;
}

export const listLicOtherPolicyAdmin = async (
  lic_id: number
): Promise<ListLicOtherPolicyResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listlicotherpolicy_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface OtherPolicyDetailItem {
  planname: string;
  policy_term: string;
  premium_term: string;
  payment_mode: string;
  topup_amount: number;
  sum_asured: number;
  premium_amount: number;
  double_accident_befit: string;
  dateofcommencement: string;
}

export interface LicInsuranceHistory {
  lic_id: number;
  premium_waiver: string;
  family_protection: string;
  gov_position_hold: string;
  person_name: string;
  relationship: string;
  position_hold: string;
  is_bankacccount: string;
  bank_name: string;
  branch_name: string;
  iban_number: string;
  account_number: string;
  uae_cusomer_que: string;
  otherpolicy_detail: OtherPolicyDetailItem[];
}

export interface AddLicInsuranceHistoryResponse {
  message: string;
  data?: number | unknown;
  success: boolean;
}

export const addLicInsuranceHistoryAdmin = async (
  data: LicInsuranceHistory
): Promise<AddLicInsuranceHistoryResponse> => {
  try {
    const response = await axiosInstance.post(
      "/lic/addlicotherpolicy_admin",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicOtherPolicyParams {
  lic_id: number;
  planname: string;
  policy_term: string;
  premium_term: string;
  payment_mode: string;
  topup_amount: number;
  sum_asured: number;
  premium_amount: number;
  double_accident_befit: string;
  dateofcommencement: string;
}

export interface AddLicOtherPolicyResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicOtherPolicyAdmin = async (
  data: AddLicOtherPolicyParams
): Promise<AddLicOtherPolicyResponse> => {
  try {
    const response = await axiosInstance.post(
      "/lic/addlicotherpolicy_admin",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicOtherPolicyParams {
  planname: string;
  policy_term: string;
  premium_term: string;
  payment_mode: string;
  topup_amount: number;
  sum_asured: number;
  premium_amount: number;
  double_accident_befit: string;
  dateofcommencement: string;
  status: string;
}

export interface UpdateLicOtherPolicyResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicOtherPolicyAdmin = async (
  policy_id: number,
  data: UpdateLicOtherPolicyParams | (LicInsuranceHistory & { status?: string })
): Promise<UpdateLicOtherPolicyResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelicotherpolicy_admin?policy_id=${policy_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicNomineeRecord {
  id: number;
  lic_id: number;
  [key: string]: unknown;
}

export interface ListLicNomineeResponse {
  message: string;
  data: LicNomineeRecord[];
  success: boolean;
}

export const listLicNomineeAdmin = async (
  lic_id: number
): Promise<ListLicNomineeResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listlicnominee_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicNomineeParams {
  lic_id: number;
  nominee_name: string;
  relationship: string;
  nominee_dob: string;
  nominee_nationality: string;
  passport_number: string;
  passport_expiry: string;
  nominee_identity_no: string;
  nominee_identity_expiry: string | null;
  country_code: string;
  nominee_local_contactno: string;
  nominee_mobileno: string;
  nominee_address: string;
  is_minor: number;
  appointee_name: string;
  realtion_with_nominee: string;
  appointee_dob: string | null;
  appointee_nationality: string;
  appointee_passportno: string;
  appointee_passport_expiry: string | null;
  appointee_identityno: string;
  appintee_identity_expiry: string | null;
  appointee_countycode: string;
  appointee_mobileno: string;
  appointee_address: string;
  appintee_digital_sign: string;
}

export interface AddLicNomineeResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicNomineeAdmin = async (
  data: AddLicNomineeParams | AddLicNomineeParams[]
): Promise<AddLicNomineeResponse> => {
  try {
    const body = Array.isArray(data) ? data : [data];
    const response = await axiosInstance.post("/lic/addlicnominee_admin", body);
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicNomineeParams {
  nominee_name: string;
  relationship: string;
  nominee_dob: string;
  nominee_nationality: string;
  passport_number: string;
  passport_expiry: string;
  nominee_identity_no: string;
  nominee_identity_expiry: string | null;
  country_code: string;
  nominee_local_contactno: string;
  nominee_mobileno: string;
  nominee_address: string;
  is_minor: number;
  appointee_name: string;
  realtion_with_nominee: string;
  appointee_dob: string | null;
  appointee_nationality: string;
  appointee_passportno: string;
  appointee_passport_expiry: string | null;
  appointee_identityno: string;
  appintee_identity_expiry: string | null;
  appointee_countycode: string;
  appointee_mobileno: string;
  appointee_address: string;
  appintee_digital_sign: string;
  status: string;
}

export interface UpdateLicNomineeResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicNomineeAdmin = async (
  nominee_id: number,
  data: UpdateLicNomineeParams
): Promise<UpdateLicNomineeResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelicnominee_admin?nominee_id=${nominee_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicHealthRecord {
  id: number;
  lic_id: number;
  [key: string]: unknown;
}

export interface ListLicHealthResponse {
  message: string;
  data: LicHealthRecord[];
  success: boolean;
}

export const listLicHealthAdmin = async (
  lic_id: number
): Promise<ListLicHealthResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listlichealth_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicHealthParams {
  lic_id: number;
  height: string;
  weight: string;
  bmi: string;
  is_smoke: number;
  smokingstop_date: string | null;
  medicalhistory: string;
  medical_his_detail: string;
  dateof_diagnosis: string | null;
  treatment_status: string;
  family_medical_history: string;
  is_preganant: number;
}

export interface AddLicHealthResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicHealthAdmin = async (
  data: AddLicHealthParams
): Promise<AddLicHealthResponse> => {
  try {
    const response = await axiosInstance.post("/lic/addlichealth_admin", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicHealthParams {
  height: string;
  weight: string;
  bmi: string;
  is_smoke: number;
  smokingstop_date: string | null;
  medicalhistory: string;
  medical_his_detail: string;
  dateof_diagnosis: string | null;
  treatment_status: string;
  family_medical_history: string;
  is_preganant: number;
  status: string;
}

export interface UpdateLicHealthResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicHealthAdmin = async (
  health_id: number,
  data: UpdateLicHealthParams
): Promise<UpdateLicHealthResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelichealth_admin?health_id=${health_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicLegalRecord {
  id: number;
  lic_id: number;
  [key: string]: unknown;
}

export interface ListLicLegalResponse {
  message: string;
  data: LicLegalRecord[];
  success: boolean;
}

export const listLicLegalAdmin = async (
  lic_id: number
): Promise<ListLicLegalResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listliclegal_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface AddLicLegalParams {
  lic_id: number;
  declartion_accepted: number;
  notfatca_holding: number;
  isverify_consent: number;
  digital_sign: string;
  date_of_sign: string;
  placeof_sign: string;
}

export interface AddLicLegalResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicLegalAdmin = async (
  data: AddLicLegalParams
): Promise<AddLicLegalResponse> => {
  try {
    const response = await axiosInstance.post("/lic/addliclegal_admin", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicLegalParams {
  declartion_accepted: number;
  notfatca_holding: number;
  isverify_consent: number;
  digital_sign: string;
  date_of_sign: string;
  placeof_sign: string;
  status: string;
}

export interface UpdateLicLegalResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicLegalAdmin = async (
  legal_id: number,
  data: UpdateLicLegalParams
): Promise<UpdateLicLegalResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updateliclegal_admin?legal_id=${legal_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicDetailRecord {
  proposal_id: number;
  [key: string]: unknown;
}

export interface GetLicDetailByIdResponse {
  message: string;
  data: LicDetailRecord;
  success: boolean;
}

export const getLicDetailById = async (
  proposal_id: number
): Promise<GetLicDetailByIdResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/getlicdetailbyid?proposal_id=${proposal_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateNewLicProposalParams {
  inward_number?: string;
  date_of_inward?: string;
  date_of_proposal?: string;
  consultant_name?: string;
  consultant_code?: string;
  chief_agent_name?: string;
  chief_agent_number?: string;
  proposal_deposit_currency?: string;
  proposal_deposit_amount?: string | number;
  proposal_number?: string;
  depositamttype?: string;
}

export interface UpdateNewLicProposalResponse {
  message: string;
  success: boolean;
  data?: unknown;
}

export const updateNewLicProposalAdmin = async (
  proposal_id: number,
  data: UpdateNewLicProposalParams
): Promise<UpdateNewLicProposalResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatenewlicproposal_admin?proposal_id=${proposal_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export const uploadFileToS3Kyc = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosInstance.post("/lic/uploaddocument", formData, {
    headers: { "Content-Type": undefined as unknown as string },
  });
  const url = response.data?.data;
  if (!url || typeof url !== "string") {
    throw new Error(response.data?.message ?? "Upload failed.");
  }
  return url;
};


export const runKycDocumentFlow = async (
  personalPayload: AddPersonalInfoParams,
  files: File[]
): Promise<{ success: boolean; lic_id?: number; message?: string }> => {
  try {
    const personalResponse = await addPersonalInfoAdmin(personalPayload);
    if (!personalResponse.success || personalResponse.data == null) {
      return {
        success: false,
        message: personalResponse.message ?? "Failed to save personal info",
      };
    }

    const lic_id = personalResponse.data;

    const documentNames = ["Document 1", "Document 2", "Document 3", "Document 4"];
    for (let i = 0; i < files.length; i++) {
      const doc_typeid = i + 1;
      const document_url = await uploadFileToS3Kyc(files[i]);
      await addLicDocumentAdmin({
        doc_typeid,
        lic_id,
        document_url,
        document_name: documentNames[i] ?? `Document ${i + 1}`,
        note: "",
      });
    }

    return { success: true, lic_id };
  } catch (err: any) {
    const message =
      err?.message ?? err?.response?.data?.message ?? "KYC document flow failed";
    return { success: false, message };
  }
};

export interface AddLicDocumentParams {
  doc_typeid: number;
  lic_id: number;
  document_url: string;
  document_name?: string;
  note: string;
}

export interface AddLicDocumentResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addLicDocumentAdmin = async (
  data: AddLicDocumentParams
): Promise<AddLicDocumentResponse> => {
  try {
    const response = await axiosInstance.post("/lic/addlicdocument_admin", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface UpdateLicDocumentParams {
  doc_typeid: number;
  document_url: string;
  note: string;
  status: string;
}

export interface UpdateLicDocumentResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const updateLicDocumentAdmin = async (
  document_id: number,
  data: UpdateLicDocumentParams
): Promise<UpdateLicDocumentResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lic/updatelicdocument_admin?document_id=${document_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface DeleteLicDocumentResponse {
  message: string;
  data?: number;
  success: boolean;
}

export const deleteLicDocumentAdmin = async (
  document_id: number
): Promise<DeleteLicDocumentResponse> => {
  try {
    const response = await axiosInstance.delete(
      `/lic/deletelicdocument_admin?document_id=${document_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicDocumentRecord {
  id: number;
  lic_id: number;
  [key: string]: unknown;
}

export interface ListLicDocumentsParams {
  lic_id: number;
  document_id: number;
  document_typename: string;
  status: string;
}

export interface ListLicDocumentsResponse {
  message: string;
  data: LicDocumentRecord[];
  success: boolean;
}

export const listLicDocumentsAdmin = async (
  data: ListLicDocumentsParams
): Promise<ListLicDocumentsResponse> => {
  try {
    const response = await axiosInstance.post(
      "/lic/listlicdocuments_admin",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicDocumentTypeRecord {
  id: number;
  document_typename: string;
}

export interface ListLicDocumentTypeResponse {
  message: string;
  data: LicDocumentTypeRecord[];
  success: boolean;
}

export const listLicDocumentTypeAdmin = async (
  lic_id: number
): Promise<ListLicDocumentTypeResponse> => {
  try {
    const response = await axiosInstance.get(
      `/lic/listlicdocumenttype_admin?lic_id=${lic_id}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};

export interface LicProposalListItem {
  id?: number;
  user_id?: number;
  country_code?: string;
  customer_mobile?: string;
  depositamttype?: string;
  inward_number?: string;
  date_of_inward?: string;
  date_of_proposal?: string;
  consultant_name?: string;
  consultant_code?: string;
  chief_agent_name?: string;
  chief_agent_number?: string;
  proposal_deposit_currency?: string;
  proposal_deposit_amount?: number;
  proposal_number?: string;
  status?: string;
  signed_doc_url?: string | null;
  note?: string;
  createdon?: number | string | null;
  updatedon?: number | string | null;
  updatedby?: number | string | null;
  [key: string]: unknown;
}

export interface ListLicProposalParams {
  page?: number;
  per_page?: number;
  from_date?: string;
  to_date?: string;
  status?: string;
  proposal_number?: string;
  chief_agent_number?: string;
  proposal_id?: number;
  user_id?: number;
  customer_mobile?: string;
}

export interface ListLicProposalResponse {
  message: string;
  data: {
    lic_proposals: LicProposalListItem[];
    pagination: {
      page: number;
      per_page: number;
      total_pages: number;
      total_items: number;
    };
  };
  success: boolean;
}

export const listLicProposalAdmin = async (
  params: ListLicProposalParams = {}
): Promise<{
  data: LicProposalListItem[];
  success: boolean;
  message?: string;
  total?: number;
  total_pages?: number;
  per_page?: number;
}> => {
  try {
    const body = {
      page: params.page ?? 1,
      per_page: params.per_page ?? 10,
      from_date: params.from_date ?? "",
      to_date: params.to_date ?? "",
      status: params.status ?? "",
      proposal_number: params.proposal_number ?? "",
      chief_agent_number: params.chief_agent_number ?? "",
      proposal_id: params.proposal_id ?? 0,
      user_id: params.user_id ?? 0,
      customer_mobile: params.customer_mobile ?? "",
    };
    const response = await axiosInstance.post("/lic/listlicproposal_admin", body);
    const res = response.data as ListLicProposalResponse;
    const list = res.data?.lic_proposals ?? [];
    const pagination = res.data?.pagination ?? {};
    return {
      data: list,
      success: res.success ?? false,
      message: res.message,
      total: pagination.total_items,
      total_pages: pagination.total_pages,
      per_page: pagination.per_page ?? body.per_page,
    };
  } catch (error: any) {
    throw error.response?.data ?? error.message;
  }
};
